import { createAsyncAction } from 'typesafe-actions';
import { HealthcheckInfo } from '@rootCommon/types/healthcheck';

// eslint-disable-next-line import/prefer-default-export
export const fetchHealthcheck = createAsyncAction(
  'FETCH_HEALTHCHECK_REQUEST',
  'FETCH_HEALTHCHECK_SUCCESS',
  'FETCH_HEALTHCHECK_FAILURE',
)<undefined, HealthcheckInfo, Error>();
